<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: null,
    },
    symbol: {
      type: String,
      default: '£',
    },
  },
  data: () => ({
    input: null,
  }),
  methods: {
    handleInput(input) {
      this.input = input.target.value
      this.$emit('input', this.input || null)
    },
    handleSubmit() {
      if (this.input) {
        this.$emit('submit', this.input)
      }
    },
    handleClear() {
      this.input = null
      this.$refs.input.$el.value = null
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <form @submit.prevent="handleSubmit">
      <BaseInputText
        ref="input"
        :placeholder="placeholder"
        :class="$style.geolocate"
        type="number"
        min="0"
        @input="handleInput"
      />
    </form>
    <div :class="$style.symbol" v-text="symbol" />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.container {
  position: relative;
  width: 100%;
  input {
    padding: $size-input-padding-top 0;

    &::placeholder {
      color: var(--color-primary-disabled);
    }
  }
}
.symbol {
  color: var(--color-primary-disabled);
  font-size: 1.25rem;
  position: absolute;
  left: 1.5rem;
  top: 1.5rem;
}
</style>
